import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class CompleteLiquidation extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Complete Liquidation
					</div>
					<div>
						<DownloadFile title="Download Complete Liquidation Template" url="ingest/inventory/transfer/item/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/inventory/liquidation/complete"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/Liquidation/Components/CompleteLiquidation.js